// extracted by mini-css-extract-plugin
export default {"profile":"profile_profile__aRkeG","profile_left":"profile_profile_left__lfXlj","profile_right":"profile_profile_right__slJMC"};